Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_VERSION = '6.19.7';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/core/dist/version.js
// module id = 900
// module chunks = 1